(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAutoScroll() {
    document.querySelectorAll('.carousel-content').forEach(function(carousel) {
      var slides = carousel.querySelector('slideshow-slides');
      if (!slides) return;

      var speed = 0.6; // pixels per frame — increase for faster, decrease for slower
      var paused = false;

      // pause on hover
      carousel.addEventListener('mouseenter', function() { paused = true; });
      carousel.addEventListener('mouseleave', function() { paused = false; });

      // pause on touch
      carousel.addEventListener('touchstart', function() { paused = true; });
      carousel.addEventListener('touchend', function() { paused = false; });

      function step() {
        if (!paused) {
          slides.scrollLeft += speed;

          // when it reaches the end, jump back to start seamlessly
          if (slides.scrollLeft >= slides.scrollWidth - slides.clientWidth - 1) {
            slides.scrollLeft = 0;
          }
        }
        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoScroll);
  } else {
    initAutoScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
